// Catálogo fijo de continentes para el select. Mantener en sincronía
// con el back (AirportsService.importMany valida contra la misma lista).
export const CONTINENTES = [
  'América del Norte',
  'América del Sur',
  'América Central',
  'Europa',
  'Asia',
  'África',
  'Oceanía',
  'Antártida',
];

// Definición de campos del formulario (DynamicFormModal).
export const airportFormFields = [
  { id: 'nombre', label: 'Nombre del aeropuerto', type: 'text', required: true, placeholder: 'Ej. John F Kennedy International' },
  { id: 'iata', label: 'Código IATA', type: 'text', required: true, placeholder: 'JFK', maxLength: 3 },
  { id: 'icao', label: 'Código ICAO', type: 'text', required: false, placeholder: 'KJFK', maxLength: 4 },
  { id: 'ciudad', label: 'Ciudad', type: 'text', required: true, placeholder: 'New York' },
  { id: 'pais', label: 'País', type: 'text', required: true, placeholder: 'Estados Unidos' },
  {
    id: 'continente',
    label: 'Continente',
    type: 'select',
    required: false,
    options: [{ value: '', label: '— Sin especificar —' }, ...CONTINENTES.map((c) => ({ value: c, label: c }))],
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    defaultValue: 'Activo',
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
];

// Columnas del Excel (cabeceras tal cual aparecen en el archivo).
// El import normaliza mayúsculas / sin acentos al recibir las filas.
export const columnsExcel = [
  { key: 'nombre', header: 'Nombre' },
  { key: 'iata', header: 'IATA' },
  { key: 'icao', header: 'ICAO' },
  { key: 'ciudad', header: 'Ciudad' },
  { key: 'pais', header: 'País' },
  { key: 'continente', header: 'Continente' },
  { key: 'estado', header: 'Estado' },
  { key: 'updatedAt', header: 'Última actualización' },
];
